import type { PaymentMethodType } from "@KassaroAB/shared/types/enums/PaymentMethodType";
import type { BookkeepingAccountId } from "@KassaroAB/shared/types/ids";

type BasePaymentMethod = {
  name: string;
  type: PaymentMethodType;
  bookkeepingAccountId?: BookkeepingAccountId | null;
  color?: string | null;
};

export const basePaymentMethodValues = <PaymentMethod extends BasePaymentMethod>(
  paymentMethod: PaymentMethod,
): {
  name: string;
  type: PaymentMethod["type"];
  bookkeepingAccountId: BookkeepingAccountId | null;
  color: string | null;
} => ({
  name: paymentMethod.name,
  type: paymentMethod.type,
  bookkeepingAccountId: paymentMethod.bookkeepingAccountId ?? null,
  color: paymentMethod.color ?? null,
});
